import { CoreIcon } from '../core-icon';
import appAutopassSVG from '../../assets/logos/app-autopass.svg';
import type { IconProps } from '../core-icon';

export const AppAutopassIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={appAutopassSVG} {...props} />;
};
